/* Marmotech legal pages — builds the "On this page" list from the headings in
   the page content, so it always matches whatever is written in the admin, and
   marks the section currently being read. */
(() => {
  const body = document.querySelector('[data-mt-legal-body]');
  const toc = document.querySelector('[data-mt-toc]');
  if (!body || !toc) return;

  const list = toc.querySelector('[data-mt-toc-list]');
  const aside = document.querySelector('[data-mt-legal-aside]');

  // A document with only a few top-level sections (the Terms: Part A, B, C) is
  // really organised by its sub-sections, so those are listed too.
  const sectionCount = body.querySelectorAll('h2').length;
  const selector = sectionCount < 6 ? 'h2, h3' : 'h2';
  const headings = [...body.querySelectorAll(selector)].filter((h) => h.textContent.trim());
  if (headings.length < 2) return;

  const slugify = (text) => {
    const base =
      text
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'section';
    let id = base;
    for (let n = 2; document.getElementById(id); n += 1) id = `${base}-${n}`;
    return id;
  };

  const links = new Map();
  for (const heading of headings) {
    if (!heading.id) heading.id = slugify(heading.textContent);

    const item = document.createElement('li');
    item.className = `mt-legal__toc-item mt-legal__toc-item--${heading.tagName.toLowerCase()}`;
    const link = document.createElement('a');
    link.className = 'mt-legal__toc-link';
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
    links.set(heading, link);
  }
  toc.classList.add('is-ready');

  // Always open beside the document; collapsed above it on narrow screens.
  const wide = window.matchMedia('(min-width: 990px)');
  const syncOpen = () => {
    toc.open = wide.matches;
  };
  syncOpen();
  wide.addEventListener('change', syncOpen);

  toc.querySelector('summary').addEventListener('click', (event) => {
    if (wide.matches) event.preventDefault();
  });

  list.addEventListener('click', (event) => {
    if (event.target.closest('a') && !wide.matches) toc.open = false;
  });

  // The current section is the last heading to have scrolled past the line
  // just under the sticky header.
  let current = null;
  const readingLine = 140;

  const keepVisible = (link) => {
    if (!aside || aside.scrollHeight <= aside.clientHeight) return;
    const linkBox = link.getBoundingClientRect();
    const asideBox = aside.getBoundingClientRect();
    if (linkBox.top < asideBox.top + 48) aside.scrollTop -= asideBox.top + 48 - linkBox.top;
    else if (linkBox.bottom > asideBox.bottom - 24) aside.scrollTop += linkBox.bottom - asideBox.bottom + 24;
  };

  const update = () => {
    let active = null;
    for (const heading of headings) {
      if (heading.getBoundingClientRect().top - readingLine <= 0) active = heading;
      else break;
    }
    if (active === current) return;
    if (current) links.get(current).removeAttribute('aria-current');
    current = active;
    if (current) {
      const link = links.get(current);
      link.setAttribute('aria-current', 'location');
      if (wide.matches) keepVisible(link);
    }
  };

  let queued = false;
  window.addEventListener(
    'scroll',
    () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        update();
      });
    },
    { passive: true }
  );
  update();
})();
